import { createReducer, standardReducer } from "./helpers";
import * as types from "actions/messagingActionTypes";

const initialState = {
  rootMessages: {
    byId: {},
    messages: [],
  },
  childrenMessages: {
    byId: {},
    messages: [],
    isfetching: false,
    isfetched: false,
  },
  isfetching: false,
  isfetched: false,
  error: {},
  MESSAGING_ON_POST_MESSAGE_SUCCESS: false,
  MESSAGING_POST_MESSAGE_SUCCESS: false,
};

const reducer = createReducer(initialState, {
  [types.MESSAGING_ROOT_MESSAGE_BEGIN]: standardReducer,
  [types.MESSAGING_ROOT_MESSAGE_SUCCESS]: standardReducer,
  [types.MESSAGING_ROOT_MESSAGE_ERROR]: standardReducer,
  [types.MESSAGING_CHILDREN_MESSAGE_BEGIN]: standardReducer,
  [types.MESSAGING_CHILDREN_MESSAGE_SUCCESS]: standardReducer,
  [types.MESSAGING_CHILDREN_MESSAGE_ERROR]: standardReducer,
  [types.MESSAGING_POST_MESSAGE_BEGIN]: standardReducer,
  [types.MESSAGING_ON_POST_MESSAGE_SUCCESS]: standardReducer,
  [types.MESSAGING_POST_MESSAGE_SUCCESS]: standardReducer,
  [types.MESSAGING_POST_MESSAGE_ERROR]: standardReducer,
});

export default reducer;



// WEBPACK FOOTER //
// ./reducers/messagingReducer.js